/**
 * The Contruent Theme's Scripts Entrypoint.
 *
 * This file serves as a place to import all of the JS that will eventually be bundled by Webpack to form the production-ready version.
 *
 * @author Nick Patterson <nick@fifteen4.com>
 */

// External

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

// Internal

import './includes/blog-grids.js';
import './includes/archive-taxonomy-dropdowns.js';
import './includes/mobile-nav.js';
import './includes/subnav.js';
import './includes/promo.js';
import './includes/scroll-to-links.js';

// Kitchen sink

( function( $ ) {

    // Make accordions refresh the scroll trigger

    const toggleDurationInMs = 1250;
    $( '.et_pb_toggle_title' ).on( 'click', ( e ) => window.setTimeout( ScrollTrigger.refresh, toggleDurationInMs ) )

    
} )( jQuery );